export default __webpack_public_path__ + "static/media/Work_order_Filled.bf10b893.svg";